<template>
  <div>
    <NavTop/>
    <NavDark/>

    <div class="gray py-3">
      <div class="container">
        <div class="row">
          <div class="colxl-12 col-lg-12 col-md-12">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item"><router-link to="/">Hjem</router-link></li>
                <li class="breadcrumb-item active" aria-current="page">Blog</li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
    </div>

    <section class="middle">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
            <div class="sec_title position-relative text-center">
              <h2 class="off_title">Seneste Nyt</h2>
              <h3 class="ft-bold pt-3">Vores Blog</h3>
            </div>
          </div>
        </div>

        <div class="row">
          <div v-for="item in posts" :key="item.id" class="col-xl-4 col-lg-4 col-md-4 col-sm-12">
            <div class="_blog_wrap">
              <div class="_blog_thumb mb-2">
                <router-link :to="`/blog/${item.slug}`" class="d-block"><img :src="item.image" class="img-fluid rounded" :alt="item.title" /></router-link>
              </div>
              <div class="_blog_caption">
                <span class="text-muted">{{item.date}}</span>
                <h5 class="bl_title lh-1 mt-2"><router-link :to="`/blog/${item.slug}`">{{item.title}}</router-link></h5>
                <p>{{item.description}}</p>
                <router-link :to="`/blog/${item.slug}`" class="text-dark fs-sm">Læs mere..</router-link>
              </div>
            </div>
          </div>
        </div>

      </div>
    </section>

    <FooterTopTwo/>
    <FooterDark/>
    <ScrollToTop/>

  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import FooterDark from '@/components/footer/footer-dark.vue';
import FooterTopTwo from '@/components/footer/footer-top-two.vue';
import NavDark from '@/components/navbar/nav-dark.vue';
import NavTop from '@/components/navbar/nav-top.vue';
import ScrollToTop from '@/components/scroll-to-top.vue';

// Importer din nye service
import { useBlog } from '@/services/blogService'

const { getAllPosts } = useBlog();
const posts = ref([]);

onMounted(() => {
  posts.value = getAllPosts();
});
</script>